import JobRequest from 'components/view/jobRequests/jobRequestsHistory/JobRequests'
import {tabNames, TabType} from 'router/settings'
import {ReactStateDeclaration} from '@uirouter/react'
import store from 'redux/config'
import {fetchJobRequestOptions, fetchJobStatusRequests, fetchStudyGroups} from '../../redux/jobRequests/jobRequests.duck'

const jobRequestsState = {
  name: 'job-requests',
  url: '/job-requests?pageIndex&pageSize&startCursor&endCursor&pageDirection&category&sorting',
  component: JobRequest,
  resolve: [{
    token: 'title',
    resolveFn: () => tabNames[TabType.jobRequests],
  }],
  onEnter: () => {
    const {dispatch} = store
    dispatch(fetchJobRequestOptions())
    dispatch(fetchStudyGroups())
    dispatch(fetchJobStatusRequests())
  },
  params: {
    pageSize: {value: 10, type: 'int', squash: true},
    pageIndex: {value: 0, type: 'int', squash: true},
    startCursor: {value: null, type: 'string'},
    endCursor: {value: null, type: 'string'},
    pageDirection: {value: null, type: 'string'},
    sorting: {value: {id: 'created', desc: true}, type: 'json', squash: true},
    category: {value: null, type: 'string'},
  },
} as ReactStateDeclaration

export default jobRequestsState
